export const nba = [
  {
    sno: "1",
    name: "B.E Civil Engineering",
    acc_stat: "1st Accreditation",
    year: "2004",
    period: "3 years",
  },
  {
    sno: "2",
    name: "B.E Civil Engineering",
    acc_stat: "2nd Accreditation",
    year: "2009",
    period: "3 years",
  },
  {
    sno: "3",
    name: "B.E Civil Engineering",
    acc_stat: "3rd Accreditation",
    year: "2013",
    period: "2 years",
  },
  {
    sno: "4",
    name: "B.E Civil Engineering",
    acc_stat: "4th Accreditation",
    year: "2021",
    period: "3 years",
  },
  {
    sno: "5",
    name: "B.E Mechanical Engineering",
    acc_stat: "1st Accreditation",
    year: "2004",
    period: "5 Years",
  },
  {
    sno: "6",
    name: "B.E Mechanical Engineering",
    acc_stat: "2nd Accreditation",
    year: "2012",
    period: "2 years",
  },
  {
    sno: "7",
    name: "B.E Mechanical Engineering",
    acc_stat: "3rd Accreditation",
    year: "2021",
    period: "3 years",
  },
  {
    sno: "8",
    name: "B.E- Electrical and Electronics Engineering",
    acc_stat: "1st Accreditation",
    year: "2004",
    period: "3 years",
  },
  {
    sno: "9",
    name: "B.E- Electrical and Electronics Engineering",
    acc_stat: "2nd Accreditation",
    year: "2009",
    period: "3 years",
  },
  {
    sno: "10",
    name: "B.E- Electrical and Electronics Engineering",
    acc_stat: "3rd Accreditation",
    year: "2013",
    period: "2 years",
  },
  {
    sno: "11",
    name: "B.E- Electrical and Electronics Engineering",
    acc_stat: "4th Accreditation",
    year: "2021",
    period: "3 years",
  },
  {
    sno: "12",
    name: "B.E - Electronics and Communication Engineering",
    acc_stat: "1st Accreditation(Tier-II)",
    year: "2009",
    period: "3 years",
  },
  {
    sno: "13",
    name: "B.E - Electronics and Communication Engineering",
    acc_stat: "1st Accreditation(Tier-I)",
    year: "2026",
    period: "3 years",
  },
  {
    sno: "14",
    name: "M.E- Manufacturing",
    acc_stat: "1st Accreditation",
    year: "2013",
    period: "3 years",
  },
];
export const nba_menu = [
  {
    id: "1",
    path: "/Nba",
    link: "About",
    arl: "l",
  },

  {
    id: "2",
    path: "/Nba/Nbadoc",
    link: "NBA Documents",
    arl: "l",
  },
  {
    id: "3",
    path: "/Nba/Nba_sar",
    link: "Self Assessment Report",
    arl: "l",
  },
];
export const nba_doc = [
  {
    id: "6",
    program: "NBA 2026",
    pdf: "https://drive.google.com/file/d/17G6ZGMt_w5YpLl-wHLEAS5TEmMlzcVZB/view?usp=sharing",
  },
  {
    id: "5",
    program: "NBA 2024",
    pdf: "https://drive.google.com/file/d/1ohculzgXvFiWfgd8K7Qd_3g0V9I9nuhE/view?usp=sharing",
  },
  {
    id: "1",
    program: "NBA 2021",
    pdf: "https://drive.google.com/file/d/1ldXwtFLlZI4E9eQLrdYNSkRz9ueKPYJj/view",
  },
  {
    id: "2",
    program: "NBA 2013",
    pdf: "https://drive.google.com/file/d/1a5tV44qDQ_KOXKp33GiWcv-IA9zb39VH/view",
  },

  {
    id: "3",
    program: "NBA 2009",
    pdf: "https://drive.google.com/file/d/157ogzVgdGo7y4txJy_kzzJvz_n0ZIarb/view",
  },
  {
    id: "4",
    program: "NBA 2004",
    pdf: "https://drive.google.com/file/d/1JNp0G8foTwokxg-D4NVaTZyaypvz_IYg/view",
  },
];
export const nba_civ_sar = [
  {
    id: "1",
    program: "Civil SAR",
    pdf: "https://drive.google.com/file/d/1jSHxMjKlvbqoHc4tP67HRfxtLBmnw0Fd/view",
  },
];
export const nba_mec_sar = [
  {
    id: "1",
    program: "Mechanical SAR",
    pdf: "https://drive.google.com/file/d/16VVjQGMpaF07AgCPrZtXydNvb17fVEsK/view",
  },
];

export const nba_ece_sar = [
  {
    id: "1",
    program:"SAR (ECE) 2024-25",
    pdf:"https://drive.google.com/file/d/1JY0rQtCyMHHaPl3ctsuyymZks7rlJxQc/view?usp=sharing",
  },
]
export const nba_details = [
  {
    id: "1",
    heading: "NBA Accreditation - B.E Civil Engineering",
    component: "table",
    structure: {
      data: [
        {
          sno: "1",
          programme: "B.E Civil Engineering",
          status: "1st Accreditation",
          academicyear: "2004",
          period: "3 years",
        },
        {
          sno: "2",
          programme: "B.E Civil Engineering",
          status: "2nd Accreditation",
          academicyear: "2009",
          period: "3 years",
        },
        {
          sno: "3",
          programme: "B.E Civil Engineering",
          status: "3rd Accreditation",
          academicyear: "2013",
          period: "2 years",
        },
        {
          sno: "4",
          programme: "B.E Civil Engineering",
          status: "4th Accreditation",
          academicyear: "2021",
          period: "3 years",
        },
      ],
      columns: [
        { field: "sno", header: "SNO" },
        { field: "programme", header: "NAME OF PROGRAMME" },
        { field: "status", header: "ACCREDITATION STATUS" },
        { field: "academicyear", header: "ACADEMIC YEAR" },
        { field: "period", header: "PERIOD" },
      ],
    },
  },
  {
    id: "2",
    heading: "NBA Accreditation - B.E Mechanical Engineering",
    component: "table",
    structure: {
      data: [
        {
          sno: "1",
          programme: "B.E Mechanical Engineering",
          status: "1st Accreditation",
          academicyear: "2004",
          period: "5 Years",
        },
        {
          sno: "2",
          programme: "B.E Mechanical Engineering",
          status: "2nd Accreditation",
          academicyear: "2012",
          period: "2 years",
        },
        {
          sno: "3",
          programme: "B.E Mechanical Engineering",
          status: "3rd Accreditation",
          academicyear: "2021",
          period: "3 years",
        },
      ],
      columns: [
        { field: "sno", header: "SNO" },
        { field: "programme", header: "NAME OF PROGRAMME" },
        { field: "status", header: "ACCREDITATION STATUS" },
        { field: "academicyear", header: "ACADEMIC YEAR" },
        { field: "period", header: "PERIOD" },
      ],
    },
  },
  {
    id: "3",
    heading: "NBA Accreditation - B.E- Electrical and Electronics Engineering",
    component: "table",
    structure: {
      data: [
        {
          sno: "1",
          programme: "B.E- Electrical and Electronics Engineering",
          status: "1st Accreditation",
          academicyear: "2004",
          period: "3 years",
        },
        {
          sno: "2",
          programme: "B.E- Electrical and Electronics Engineering",
          status: "2nd Accreditation",
          academicyear: "2009",
          period: "3 years",
        },
        {
          sno: "3",
          programme: "B.E- Electrical and Electronics Engineering",
          status: "3rd Accreditation",
          academicyear: "2013",
          period: "2 years",
        },
        {
          sno: "4",
          programme: "B.E- Electrical and Electronics Engineering",
          status: "4th Accreditation",
          academicyear: "2021",
          period: "3 years",
        },
      ],
      columns: [
        { field: "sno", header: "SNO" },
        { field: "programme", header: "NAME OF PROGRAMME" },
        { field: "status", header: "ACCREDITATION STATUS" },
        { field: "academicyear", header: "ACADEMIC YEAR" },
        { field: "period", header: "PERIOD" },
      ],
    },
  },
  {
    id: "4",
    heading:
      "NBA Accreditation - B.E -Electronics and Communication Engineering",
    component: "table",
    structure: {
      data: [
        {
          sno: "1",
          programme: "B.E -Electronics and Communication Engineering",
          status: "2nd Accreditation",
          academicyear: "2009",
          period: "3 years",
        },
      ],
      columns: [
        { field: "sno", header: "SNO" },
        { field: "programme", header: "NAME OF PROGRAMME" },
        { field: "status", header: "ACCREDITATION STATUS" },
        { field: "academicyear", header: "ACADEMIC YEAR" },
        { field: "period", header: "PERIOD" },
      ],
    },
  },
  {
    id: "5",
    heading: "NBA Accreditation -	M.E- Manufacturing",
    component: "table",
    structure: {
      data: [
        {
          sno: "1",
          programme: "M.E- Manufacturing",
          status: "1st Accreditation",
          academicyear: "2013",
          period: "3 years",
        },
      ],
      columns: [
        { field: "sno", header: "SNO" },
        { field: "programme", header: "NAME OF PROGRAMME" },
        { field: "status", header: "ACCREDITATION STATUS" },
        { field: "academicyear", header: "ACADEMIC YEAR" },
        { field: "period", header: "PERIOD" },
      ],
    },
  },
];

// SNO	NAME OF PROGRAMME	ACCREDITATION STATUS	ACADEMIC YEAR	PERIOD
